import { useState } from "react";

import TabButton from "../../../Components/common/TabButton/TabButton";
import MailTransferForm from "../components/MailTransferForm";
import WhitelistForm from "../components/WhitelistForm";
import BlacklistForm from "../components/BlacklistForm";
import UrlSettingsForm from "../components/UrlSettingsForm";
import UrlRewriteForm from "../components/UrlRewriteForm";
import SpamSettingsForm from "../components/SpamSettingsForm";
import EmailNotificationForm from "../components/EmailNotificationForm";
import FileTypeSettingsForm from "../components/FileTypeSettingsForm";
import ResetSettingsForm from "../components/ResetSettingsForm";
import GeneralSettingsForm from "../components/GeneralSettingsForm";
import AlertSettingsForm from "../components/AlertSettingsForm";

const MailGateway = ({ selectedProduct, selectedHost }) => {
  const [active, setActive] = useState("Mail Transfer");

  return (
    <div className="products-body">
      <div className="button-block">
        <TabButton title="Mail Transfer" onClick={setActive} active={active} />
        <TabButton title="Whitelist" onClick={setActive} active={active} />
        <TabButton title="Blacklist" onClick={setActive} active={active} />
        <TabButton title="Url" onClick={setActive} active={active} />
        <TabButton title="Url Rewrite" onClick={setActive} active={active} />
        <TabButton title="Spam" onClick={setActive} active={active} />
        <TabButton title="Email Notification" onClick={setActive} active={active} />
        <TabButton title="File Type" onClick={setActive} active={active} />
        <TabButton title="General" onClick={setActive} active={active} />
        <TabButton title="Alert" onClick={setActive} active={active} />
        <TabButton title="Reset" onClick={setActive} active={active} />
      </div>
      {active === "Mail Transfer" ? (
        <MailTransferForm selectedProduct={selectedProduct} selectedHost={selectedHost} />
      ) : active === "Whitelist" ? (
        <WhitelistForm selectedProduct={selectedProduct} selectedHost={selectedHost} />
      ) : active === "Blacklist" ? (
        <BlacklistForm selectedProduct={selectedProduct} selectedHost={selectedHost} />
      ) : active === "Url" ? (
        <UrlSettingsForm selectedProduct={selectedProduct} selectedHost={selectedHost} />
      ) : active === "Url Rewrite" ? (
        <UrlRewriteForm selectedProduct={selectedProduct} selectedHost={selectedHost} />
      ) : active === "Spam" ? (
        <SpamSettingsForm selectedProduct={selectedProduct} selectedHost={selectedHost} />
      ) : active === "Email Notification" ? (
        <EmailNotificationForm selectedProduct={selectedProduct} selectedHost={selectedHost} />
      ) : active === "File Type" ? (
        <FileTypeSettingsForm selectedProduct={selectedProduct} selectedHost={selectedHost} />
      ) : active === "General" ? (
        <GeneralSettingsForm selectedProduct={selectedProduct} selectedHost={selectedHost} />
      ) : active === "Alert" ? (
        <AlertSettingsForm selectedProduct={selectedProduct} selectedHost={selectedHost} />
      ) : active === "Reset" ? (
        <ResetSettingsForm selectedProduct={selectedProduct} selectedHost={selectedHost} />
      ) : null}
    </div>
  );
};

export default MailGateway;
